import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Button, Card, FormSelect } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { getCandidate } from '../../actions/candidatesActions'
import { sendTicket } from '../../actions/ticketsActions'
import Swal from 'sweetalert2'

import { Editor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { EditorState, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'

export default function Tickets() {
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()
    const [formState, setFormState] = useState({type: 'Consulta'})
    const {result} = useSelector(state=>state.tickets)

    const [coverLetterEditorState, setCoverLetterEditorState] = useState(EditorState.createEmpty())

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if(client){
            dispatch(getCandidate(client?.id))
        }
    },[dispatch, t, client])

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }
    const handleCoverLetterChange = (message) => {
        setCoverLetterEditorState(message)
        setFormState({
            ...formState,
            message: draftToHtml(convertToRaw(message.getCurrentContent()))
        })
    }

    const handleSend = async(e) => {
        e.preventDefault()
        if(formState?.message?.length > 8){
            dispatch(sendTicket(client?.id,formState))

        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('users.pleasecomplete')
            })
        }
    }
    useEffect(() => {
        if(result){
            setFormState({type: 'Consulta'})
            setCoverLetterEditorState(EditorState.createEmpty())
            Swal.fire({
                showConfirmButton: true,
                icon: 'success',
                text: t('tickets.'+result)
            })
        }
    // eslint-disable-next-line
    }, [result])

    return (
        <>
            <Container className='cuerpo'>
                <Row className='mb-4'>
                    <Col className='d-flex align-items-center'>
                        <img src="/images/menus/ticket.svg" alt="Tickets" />
                        <h1 className='ms-2 m-0'>{t('menus.tickets')}</h1>
                    </Col>
                </Row>
                <Form onSubmit={handleSend}>
                    <Row className="mt-2">
                        <Col>
                            <Card className='mb-5 sombra'>
                                <Card.Body className='px-5 pt-5'>
                                    <Row>
                                        <Col>
                                            <h3>{t('tickets.title')}</h3>
                                            {t('tickets.phrase')}
                                        </Col>
                                    </Row>
                                    <Row className="mt-3 mb-4">
                                        <Col xs='12' lg='6' className='mb-2'>
                                            <Form.Label htmlFor='sex'>{t('tickets.type')}</Form.Label>
                                            <FormSelect
                                                name='type'
                                                onChange={handleInputChange}
                                                required
                                                className='form-control'
                                                value={formState.type}
                                            >
                                                <option value="Consulta">{t('tickets.consult')}</option>
                                                <option value="Mejora">{t('tickets.improve')}</option>
                                                <option value="Incidencia">{t('tickets.incidence')}</option>
                                            </FormSelect>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="my-2">
                                            <Form.Label htmlFor='myFile'>{t('tickets.message')}</Form.Label>
                                            <Editor
                                                toolbar={{
                                                    options: ['inline', 'list', 'textAlign','history'],
                                                    inline: { options: ['bold', 'italic', 'underline'] },
                                                    list: { options: ['unordered', 'ordered'] },
                                                    textAlign: { options: [] }
                                                }}
                                                editorState={coverLetterEditorState}
                                                onEditorStateChange={handleCoverLetterChange}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="my-3 d-flex justify-content-end">
                                        <Col xs='12' lg='4'>
                                            <Button type="submit" className="btn-primary w-100 my-2">{t('global.send')}</Button>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Form>
            </Container>
        </>
    )
}